import { ArrowUpRight, Droplets, MapPin, SunMedium, Wrench } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { useLanguage } from "../i18n/translations";

const PARTNER_URL = new URL(process.env.REACT_APP_SERVICE_PARTNER_URL).href;
const SERVICE_ICONS = [SunMedium, Wrench, Droplets];

export const ServicePartner = () => {
  const { t } = useLanguage();
  const reduceMotion = useReducedMotion();

  return (
    <section id="service-partner" aria-labelledby="service-partner-title"
      className="border-y border-white/10 bg-navy-900 py-14 sm:py-16" data-testid="service-partner-section">
      <motion.div initial={reduceMotion ? false : { opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
        className="mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-[280px_minmax(0,1fr)] lg:gap-16">
        <div className="min-w-0">
          <p className="text-xs font-bold uppercase text-eco-bright" data-testid="service-partner-label">{t.partner.label}</p>
          <div className="mt-6 aspect-[668/308] w-full max-w-[260px]">
            <img src="/partners/vivan-energia.png" alt="Vivan Energia" width="668" height="308"
              className="h-full w-full object-contain" loading="lazy" data-testid="service-partner-logo" />
          </div>
        </div>
        <div className="min-w-0 lg:border-l lg:border-white/10 lg:pl-12">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <h2 id="service-partner-title" className="font-display text-base font-bold text-white md:text-lg" data-testid="service-partner-name">Vivan Energia</h2>
            <span className="inline-flex items-center gap-1.5 text-xs text-slate-400" data-testid="service-partner-location">
              <MapPin size={14} aria-hidden="true" /> {t.partner.location}
            </span>
          </div>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-300 sm:text-base" data-testid="service-partner-description">{t.partner.description}</p>
          <ul className="mt-6 grid gap-4 sm:grid-cols-3" data-testid="service-partner-services">
            {t.partner.services.map((service, index) => {
              const Icon = SERVICE_ICONS[index];
              return (
                <li key={index} className="flex min-w-0 items-start gap-2.5 text-sm text-slate-200" data-testid={`service-partner-service-${index + 1}`}>
                  <Icon size={18} aria-hidden="true" className="mt-0.5 shrink-0 text-eco-bright" />
                  <span>{service}</span>
                </li>
              );
            })}
          </ul>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a href={PARTNER_URL} target="_blank" rel="noopener noreferrer"
              aria-label={`${t.partner.cta} — ${t.partner.newTab}`} title={t.partner.newTab}
              className="group inline-flex max-w-full items-center justify-center gap-2 rounded-full bg-eco-bright px-5 py-3 text-sm font-bold text-[#FFFFFF] transition-colors hover:bg-[#236337] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-eco"
              data-testid="service-partner-website-link">
              <span>{t.partner.cta}</span><ArrowUpRight size={17} aria-hidden="true" className="shrink-0 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 motion-reduce:transform-none" />
            </a>
            <span className="text-xs text-slate-400" data-testid="service-partner-domain">vivanenergia.com</span>
          </div>
        </div>
      </motion.div>
    </section>
  );
};